/**
 * turnstileConfig.ts — resolves the Cloudflare Turnstile site key at runtime.
 *
 * Uses the same Docker / dev resolution pattern as main.tsx:
 *  - Production: value comes from window.__radiriConfig (injected by docker-entrypoint.sh)
 *  - Dev:        value comes from VITE_TURNSTILE_SITE_KEY in .env.local
 */

const _cfg = (window as Window & { __radiriConfig?: Record<string, string> }).__radiriConfig ?? {}

function resolve(runtime: string | undefined, dev: string | undefined): string {
  if (runtime && !runtime.startsWith('${')) return runtime
  return dev ?? ''
}

export const turnstileSiteKey = resolve(
  _cfg.TURNSTILE_SITE_KEY,
  import.meta.env.VITE_TURNSTILE_SITE_KEY,
)
